import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

const isValidDate = (yearNum, monthNum, dayNum) => {
  const date = dayjs.utc(`${yearNum}-${String(monthNum).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`)
  return date.isValid()
    && date.year() === yearNum
    && date.month() === monthNum - 1
    && date.date() === dayNum
}

export const isValidChartUrl = (year, month, day) => {
  const yearNum = Number.parseInt(year, 10)
  const monthNum = Number.parseInt(month, 10)
  const dayNum = Number.parseInt(day, 10)
  const { endYear, endMonth, endDay } = getEndYearMonthDay()

  if (year && (yearNum < chartPageStartYear || yearNum > endYear)) {
    return false
  }
  if (month && (monthNum < 1 || monthNum > 12 || (yearNum === endYear && monthNum > endMonth))) {
    return false
  }
  if (day) {
    // 実在する日付かどうかを判定
    if (!isValidDate(yearNum, monthNum, dayNum)) {
      return false
    }
    // 未来日付の制限
    if (
      (yearNum === endYear && monthNum === endMonth && dayNum > endDay)
    ) {
      return false
    }
  }
  return true
}
